import { Link } from "react-router-dom";
import { ArrowRight, Lightbulb } from "lucide-react";

export function BrainstormSection() {
  return (
    <section className="px-6 pb-28" data-testid="section-brainstorm">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="absolute -inset-2 bg-gradient-to-r from-[#4F46E5]/15 to-[#FF5733]/15 rounded-[2rem] blur-2xl -z-10" />
          <img
            src="https://static.prod-images.emergentagent.com/jobs/742a2425-99e6-4da6-8013-d806e8e0850f/images/b5454ea7105190ef53d30702ee1b6774081bca27c9de12e08192de2a0bad3dc6.jpeg"
            alt="Engineering team laughing and high-fiving in front of a screen showing live poll results, having just reached a decision together"
            className="w-full rounded-3xl shadow-2xl border-8 border-white object-cover"
            loading="lazy"
            decoding="async"
            data-testid="brainstorm-image"
          />
        </div>
        <div className="order-1 lg:order-2">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#FF5733] bg-[#FF5733]/10 px-3 py-1.5 rounded-full mb-6">
            <Lightbulb className="w-3.5 h-3.5" /> From votes to decisions
          </span>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-4">
            Turn live results into real decisions
          </h2>
          <p className="text-slate-600 leading-relaxed mb-8 max-w-lg">
            Engineering and clinical teams alike run design-reviews and rounds on VybeMeter — polling
            the room, watching charts update in real time, and deciding next steps together while the
            data is still fresh on screen.
          </p>
          <Link
            to="/register"
            data-testid="brainstorm-cta-button"
            className="inline-flex items-center gap-2 text-white font-semibold px-6 py-3.5 rounded-full transition-transform hover:scale-105 active:scale-95"
            style={{ background: "#4F46E5" }}
          >
            Get started free <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
